export enum AppEnvEnum {
  production = 'production',
  staging = 'staging',
  development = 'development',
  qa = 'qa',
}
